<template>
    <Modal v-model="show"
        :width="1200"
        :footer-hide="true"
        title="现售单发货到转运站"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="top">
                    <Row :gutter="16">
                        <Col span="3">
                        <FormItem label="定单时间">
                            <Input :value="formatDateTimeString(orderRecord.curSaleOrderRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="定单编号">
                            <Input :value="orderRecord.curSaleOrderRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员名称">
                            <Input :value="orderRecord.deliveryAddressContacts"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员电话">
                            <Input :value="orderRecord.deliveryAddressPhone"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="3">
                        <FormItem label="定单状态">
                            <Input :value="orderRecord.curSaleOrderRecordOrderStatus"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="3">
                        <FormItem label="本定单合计">
                            <currency-input :value="orderRecord.curSaleOrderRecordTotalOrderCost"
                                readonly />
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="6">
                        <FormItem label="收货地址">
                            <Input :value="orderRecord.deliveryAddressFull"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <Col span="3">
                        <FormItem label="发货日期"
                            prop="curSaleDeliveryRecordDeliveryDate">
                            <DatePicker :value="deliveryTable.form.curSaleDeliveryRecordDeliveryDate"
                                :options="deliveryDateOptions"
                                type="date"
                                format="yyyy-MM-dd"
                                @on-change="onDeliveryDateChange" />
                        </FormItem>
                        </Col>

                        <Col span="7">
                        <FormItem label="备注">
                            <Input v-model="deliveryTable.form.curSaleDeliveryRecordRemark"></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label=" ">
                            <Button type="success"
                                @click="onSubmit">提交送货单
                            </Button>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="12">
                        <FormItem label="定单商品">
                            <Table ref="mainTable"
                                size="small"
                                :columns="orderDetail.columns"
                                :data="orderDetail.rows"
                                :height="200"
                                stripe
                                border />
                        </FormItem>
                        </Col>

                        <Col span="12">
                        <FormItem>
                            <div style="display:flex;justify-content: space-between;">
                                <span>本次发货商品</span>
                                <span style="color:red;font-size:16px;">共选择发货:{{deliveryTable.totalQuantity}}件</span>
                            </div>
                            <Table ref="deliveryTable"
                                size="small"
                                :columns="deliveryTable.columns"
                                :data="deliveryTable.rows"
                                :height="200"
                                stripe
                                border />
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="historyTable.columns"
                    size="small"
                    :data="historyTable.rows"
                    :autoHeight="true"
                    :loading="historyTable.loading"
                    :table-search="historyTable.search"
                    :table-load-event="getHistoryTableRecord" />
                </Col>
            </Row>

            <Modal v-model="warehouseModal.show"
                title="请选择发货的仓库"
                width="75"
                @on-ok="onAddProducts">
                <Row :gutter="16">
                    <Col span="24">
                    <Table ref="warehouseTable"
                        size="small"
                        :columns="warehouseModal.warehouseTable.columns"
                        :data="warehouseModal.warehouseTable.rows"
                        stripe
                        border />
                    </Col>
                </Row>
            </Modal>
        </Card>
    </Modal>

</template>

<script>
import { formatDateTimeString } from '@/libs/logic';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import DecimalInput from '@/components/number-input/decimal-input';
import CurrencyInput from '@/components/number-input/currency-input';
import { dateRender } from '@/libs/tableRowTimeRender';

import {
    getOrderDeliveryHistory,
    pageInit4CurSaleOrderDelivery,
    saveCurSaleDelivery
} from '@/api/modules/curSale-management/curSale-order';

export default {
    name: 'CurSaleOrderDelivery',
    components: {
        DecimalInput,
        CurrencyInput,
        StandPaginationTable
    },
    data() {
        const now = new Date();
        const todayValue = new Date(now.getFullYear(), now.getMonth(), now.getDate()).valueOf();

        return {
            show: false,
            innerSpin: false,
            orderUuid: '',
            curSaleOrderRecordUuid: '',
            btnLoading: false,
            orderRecord: {
                curSaleOrderRecordCreateAt: '',
                curSaleOrderRecordCode: '',
                curSaleOrderRecordOrderStatus: '',
                curSaleOrderRecordTotalOrderCost: 0,
                deliveryAddressFull: '',
                region: ''
            },
            orderDetail: {
                columns: [
                    { title: '产品编码', key: 'curSaleOrderDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'curSaleOrderDetailProductName', align: 'center' },
                    { title: '批次', key: 'curSaleOrderDetailStoreBatchCode', align: 'center' },
                    { title: '销售期限', key: 'curSaleOrderDetailStoreSalePeriod', align: 'center' },
                    { title: '现售单数量', key: 'curSaleOrderDetailOrderQuantity', align: 'center' },
                    {
                        title: '操作',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'primary',
                                    disabled: !params.row.canDelivery,
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.limitQuantity.min = 0;
                                        this.limitQuantity.max = params.row.curSaleOrderDetailOrderQuantity;
                                        this.onShowWarehouseModal(params.row);
                                    }
                                }
                            }, '发货');
                        }
                    }
                ],
                rows: []
            },
            deliveryTable: {
                columns: [
                    { title: '产品编码', key: 'curSaleOrderDetailProductCode', width: 80, align: 'center' },
                    { title: '产品名称', key: 'curSaleOrderDetailProductName', align: 'center' },
                    { title: '发货仓', key: 'warehouseName', align: 'center' },
                    { title: '最大量', key: 'warehouseProductStoreAmount', width: 80, align: 'center' },
                    {
                        title: '发货量',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h(DecimalInput, {
                                props: {
                                    value: params.row.deliveryQuantity,
                                    max: params.row.curSaleOrderDetailOrderQuantity,
                                    size: 'small',
                                    precision: 0
                                },
                                on: {
                                    change: val => {
                                        params.row.deliveryQuantity = val;
                                        this.deliveryTable.rows[params.index].deliveryQuantity = val;
                                        this.calculateTotalDeliveryAmount();
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.deliveryTable.rows.splice(params.index, 1);
                                    }
                                }
                            }, '移除');
                        }
                    }
                ],
                rows: [],
                form: {
                    curSaleDeliveryRecordDeliveryDate: '',
                    curSaleDeliveryRecordRemark: ''
                },
                totalQuantity: 0
            },
            warehouseProductStores: [],
            warehouseModal: {
                show: false,
                curSaleOrderDetailObj: null,
                warehouseTable: {
                    columns: [
                        { title: '仓存名称', key: 'warehouseName', align: 'center' },
                        { title: '批号', key: 'warehouseProductStoreBatchCode', align: 'center' },
                        {
                            title: '公开', key: 'warehouseProductStoreIsPublic', align: 'center',
                            render: (h, params) => {
                                let text = params.row.warehouseProductStoreIsPublic === 1 ? '是' : '否';
                                let color = params.row.warehouseProductStoreIsPublic === 1 ? '' : 'red';
                                return h('div', [
                                    h('span', {
                                        style: {
                                            color: color
                                        }
                                    }, text)
                                ]);
                            }
                        },
                        { title: '销售期限', key: 'warehouseProductStoreSalePeriod', align: 'center' },
                        { title: '过期时间', key: 'warehouseProductStoreExpireDate', align: 'center', render: (h, params) => dateRender(h, params.row.warehouseProductStoreExpireDate) },
                        { title: '仓存数量', key: 'warehouseProductStoreAmount', align: 'center' },
                        {
                            title: '发货量',
                            align: 'center',
                            render: (h, params) => {
                                return h(DecimalInput, {
                                    props: {
                                        value: params.row.deliveryQuantity,
                                        max: this.limitQuantity.max,
                                        precision: 0
                                    },
                                    on: {
                                        change: val => {
                                            params.row.deliveryQuantity = val;
                                            this.warehouseModal.warehouseTable.rows[params.index].deliveryQuantity = val;
                                        }
                                    }
                                });
                            }
                        }
                    ],
                    rows: []
                }
            },
            historyTable: {
                columns: [
                    { title: '送货单号', key: 'curSaleDeliveryRecordCode', width: 180, align: 'center' },
                    { title: '发货日期', key: 'curSaleDeliveryRecordDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.curSaleDeliveryRecordDeliveryDate) },
                    { title: '制单日期', key: 'curSaleDeliveryRecordCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.curSaleDeliveryRecordCreateAt) },
                    { title: '产品编码', key: 'productCode', align: 'center' },
                    { title: '产品名称', key: 'productName', align: 'center' },
                    { title: '发货仓', key: 'warehouseName', align: 'center' },
                    { title: '发货量', key: 'curSaleDeliveryDetailQuantity', align: 'center' },
                    { title: '运费', key: 'curSaleDeliveryDetailTotalLogisticsPrice', align: 'center' },
                    { title: '现售单价', key: 'curSaleOrderDetailProductDisplayPrice', align: 'center' },
                    { title: '最新价', key: 'curSaleDeliveryDetailLatestProductPrice', align: 'center' },
                    { title: '实价', key: 'curSaleDeliveryDetailActProductPrice', align: 'center' }
                ],
                rows: [],
                search: search.getSearchParams(),
                loading: false
            },
            limitQuantity: {
                min: 0,
                max: 0
            },
            deliveryDateOptions: {
                disabledDate(date) {
                    const v = date.valueOf();
                    return date && v < todayValue;
                }
            }
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
                this.deliveryTable.rows = [];
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        formatDateTimeString,
        init() {
            // const query = this.$route.query;
            if (this.orderUuid) {
                this.curSaleOrderRecordUuid = this.orderUuid;

                this.innerSpin = true;
                pageInit4CurSaleOrderDelivery(this.curSaleOrderRecordUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        const orderDetailRsp = res.data.orderDetail;
                        this.orderRecord = Object.assign(this.orderRecord, orderDetailRsp.orderRecord);
                        this.orderDetail.rows = orderDetailRsp.orderDetail;

                        // 现售单产品库存信息
                        this.warehouseProductStores = res.data.productStore;

                        // 历史送货单
                        this.historyTable.rows = res.data.deliveryHistory.records;
                        search.globalSetFilterRecordCount(this.historyTable.search, res.data.deliveryHistory.filterRecordCount);
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        calculateTotalDeliveryAmount() {
            this.deliveryTable.totalQuantity = this.deliveryTable.rows.map(e => {
                return e.deliveryQuantity;
            }).reduce((total, num) => {
                return total + num;
            });
        },
        onSubmit() {
            // console.log('submit');

            if (this.deliveryTable.form.curSaleDeliveryRecordDeliveryDate === '') {
                this.$Modal.error({ title: '发货日期不能为空', content: '' });
                return;
            }

            const submitData = {
                curSaleOrderRecordUuid: this.curSaleOrderRecordUuid,
                curSaleDeliveryRecordDeliveryDate: this.deliveryTable.form.curSaleDeliveryRecordDeliveryDate,
                curSaleDeliveryRecordRemark: this.deliveryTable.form.curSaleDeliveryRecordRemark,
                deliveryDeliveryDetails: this.deliveryTable.rows.map(r => {
                    return {
                        storeUuid: r.warehouseProductStoreUuid,
                        warehouseUuid: r.warehouseUuid,
                        distributionStationUuid: r.curSaleOrderDetailRelateDistributionStationUuid,
                        curSaleOrderDetailUuid: r.curSaleOrderDetailUuid,
                        deliveryQuantity: r.deliveryQuantity
                    };
                })
            };

            // console.log(submitData);

            this.innerSpin = true;
            saveCurSaleDelivery(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.show = false;
                            this.$parent.init();
                            // window.location.reload();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        onShowWarehouseModal(row) {
            this.warehouseModal.curSaleOrderDetailObj = row;

            const productUuid = row.curSaleOrderDetailProductUuid;
            const curSaleOrderDetailStoreBatchCode = row.curSaleOrderDetailStoreBatchCode;
            const curSaleOrderDetailStoreSalePeriod = row.curSaleOrderDetailStoreSalePeriod;

            const productFilter = this.warehouseProductStores
                .filter(p => p.warehouseProductStoreProductUuid === productUuid
                    && p.warehouseProductStoreBatchCode === curSaleOrderDetailStoreBatchCode
                    && p.warehouseProductStoreSalePeriod === curSaleOrderDetailStoreSalePeriod)
                .map(p => {
                    return {
                        warehouseUuid: p.warehouseProductStoreWarehouseUuid,
                        warehouseName: p.warehouseName,
                        warehouseProductStoreAmount: p.warehouseProductStoreAmount,
                        deliveryQuantity: p.warehouseProductStoreAmount >= row.curSaleOrderDetailOrderQuantity ? row.curSaleOrderDetailOrderQuantity : 0,
                        curSaleOrderDetailProductUuid: productUuid,
                        warehouseProductStoreUuid: p.warehouseProductStoreUuid,
                        warehouseProductStoreBatchCode: p.warehouseProductStoreBatchCode,
                        warehouseProductStoreIsPublic: p.warehouseProductStoreIsPublic,
                        warehouseProductStoreBatchPrice: p.warehouseProductStoreBatchPrice,
                        warehouseProductStoreExpireDate: p.warehouseProductStoreExpireDate,
                        warehouseProductStoreSalePeriod: p.warehouseProductStoreSalePeriod,
                        curSaleOrderDetailOrderQuantity: row.curSaleOrderDetailOrderQuantity
                    };
                });
            this.warehouseModal.warehouseTable.rows = productFilter;
            this.warehouseModal.show = true;
        },
        onAddProducts() {
            const avaliable = this.warehouseModal.warehouseTable.rows.filter(r => r.deliveryQuantity > 0);
            if (avaliable.length > 0) {
                avaliable.forEach(item => {
                    const existsIndex = this.deliveryTable.rows.findIndex(
                        d => d.warehouseUuid === item.warehouseUuid
                            && d.curSaleOrderDetailProductUuid === item.curSaleOrderDetailProductUuid
                            && d.warehouseProductStoreBatchCode === item.warehouseProductStoreBatchCode
                            && d.warehouseProductStoreSalePeriod === item.warehouseProductStoreSalePeriod);

                    if (existsIndex >= 0) {
                        this.deliveryTable.rows[existsIndex].deliveryQuantity = item.deliveryQuantity;
                    }
                    else {
                        const newRow = Object.assign(item, this.warehouseModal.curSaleOrderDetailObj);
                        this.deliveryTable.rows.push(newRow);
                    }
                });
                this.calculateTotalDeliveryAmount();
            }
        },
        onDeliveryDateChange(date) {
            this.deliveryTable.form.curSaleDeliveryRecordDeliveryDate = date;
        },
        getHistoryTableRecord(reset = false) {
            const queryData = Object.assign(this.historyTable.search, {
                curSaleOrderRecordUuid: this.curSaleOrderRecordUuid
            });

            if (reset) {
                search.globalResetSearch(this.historyTable.search);
            }

            getOrderDeliveryHistory(queryData).then(res => {
                if (res.code === 0) {
                    this.historyTable.rows = res.data.records;
                    search.globalSetFilterRecordCount(this.historyTable.search, res.data.filterRecordCount);
                }
            }).catch(() => {

            });
        }
    }
};
</script>

<style scoped>
</style>
